import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { StandardTypeDto } from '../../../../generated-model/models';
import { PageResponse } from '../../../shared/commons/page-response';

@Injectable({ providedIn: 'root' })
export class StandardTypeService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = '/api/master/standard-types';

  getAllStandardTypes(page: number, size: number, search: string = "", state: number | null = null): Observable<PageResponse<StandardTypeDto>> { return this.http.get<PageResponse<StandardTypeDto>>(this.apiUrl + '?page=' + page + '&size=' + size + '&search=' + encodeURIComponent(search) + (state == null ? '' : '&state=' + state)); }
  getStandardTypeById(id: number): Observable<StandardTypeDto> { return this.http.get<StandardTypeDto>(`${this.apiUrl}/${id}`); }
  createStandardType(dto: StandardTypeDto): Observable<StandardTypeDto> { return this.http.post<StandardTypeDto>(this.apiUrl, dto); }
  updateStandardType(id: number, dto: StandardTypeDto): Observable<StandardTypeDto> { return this.http.put<StandardTypeDto>(`${this.apiUrl}/${id}`, dto); }
  deleteStandardType(id: number): Observable<void> { return this.http.delete<void>(`${this.apiUrl}/${id}`); }
}
